/* eslint-disable */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditShippingAddressPanel from './editshippingaddresspanel'
import { EMPTY_UUID } from '../../src/logic';

var modal = require('../modal');
var tr = require('ts-translate-js').default.boundTR;

export class ShippingAddressPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showEditShippingAddressPanel: false,
            shippingAddressToModify: {
                Address: "",
                Address2: "",
                City: "",
                Province: "",
                PostalCode: "",
                Country: ""
            },
            shippingAddressErrorResult: {}
        }

    }
    
    componentDidMount() {
        this.errorModalContainerRef = React.createRef();
    }

    componentWillUnmount() {
        if (this.removeShippingAddressRequest != null) this.removeShippingAddressRequest.abort();
        if (this.updateShippingAddressRequest != null) this.updateShippingAddressRequest.abort();
    }

    refreshData() {
        this.props.onRefreshData();
    }

    handleOnClose() {
        this.props.onCloseShippingAddress()
    }

    handleOnRemove(addressID) {
        this.handleOnRemoveConfirm(addressID)
    }

    handleOnRemoveConfirm(addressID) {
        this.props.onRemoveShippingAddress(addressID)
    }

    handleOnAddNewAddress() {
        this.setState({ showEditShippingAddressPanel: true, shippingAddressToModify: { ID: EMPTY_UUID } })
    }

    handleOnEditShippingAddress(address) {
        this.setState({ showEditShippingAddressPanel: true, shippingAddressToModify: address })
    }

    handleOnModifyShippingAddress(shippingAddressToModify) {
        this.setState({ shippingAddressToModify, showEditShippingError: false })
    }

    handleOnRemoveShippingAddress(id) {
        this.removeShippingAddressRequest = tsapp.mvcapi.postCtl("profile/RemoveShippingAddress", { id })
                                                 .success(function (data) {
                                                     this.props.onRefreshData();
                                                 }.bind(this))
                                                 .notSuccess(function (data) {
                                                     this.setState({ showRemoveShippingError: true })
                                                     this.setState({ errorOnAction: (data.message == "PROFILE_IS_EMPTY") ? data.message : "" });
                                                 }.bind(this))
    }

    handleOnRemoveErrorShippingOK() {
        this.props.onRemoveErrorShippingOK();
        // TOCHECK
        this.setState({ showRemoveShippingError: false })
    }

    handleOnConfirmEditShippingAddress(shippingAddressToModify) {
        this.updateShippingAddressRequest = tsapp.mvcapi.postCtl("profile/UpdateShippingAddress", { address: shippingAddressToModify })
                                                 .success(function (data) {
                                                     this.setState({ showEditShippingAddressPanel: false });
                                                     this.setState({ shippingAddressToModify: null });
                                                     this.props.onRefreshData()
                                                 }.bind(this))
                                                 .notSuccess(function (data) {
                                                     this.setState({
                                                         showEditShippingError: true,
                                                         shippingAddressErrorResult: data,
                                                         errorOnAction: (data.message == "PROFILE_IS_EMPTY") ? data.message : ""
                                                     });
                                                 }.bind(this));
    }

    handleOnCancelEditShippingAddress() {
        this.setState({ showEditShippingAddressPanel: false, shippingAddressToModify: null })
    }

    
    handleOnFailedEditShippingOK() {
        this.props.onFailedEditShippingOK()
    }

    render() {
        var shippingAddressePanel = this.props.shippingaddresses.map(function (address) {
            return (
                <div key={address.ID} className="panel-body">
                    <div className="well">
                        <div className="row">
                            <div className="col-sm-12">
                                <span className="text-bold">{address.Description}</span>
                                <div className="btn-toolbar">
                                    <button className="btn btn-default" type="button" onClick={() => this.handleOnRemoveShippingAddress(address.ID)}>
                                        <span className="glyphicon glyphicon-trash"></span> {tr("shippingaddresspanel.remove")}
                                    </button>
                                    <button className="btn btn-primary" type="button" onClick={() => this.handleOnEditShippingAddress(address)}>
                                        <span className="glyphicon glyphicon-pencil"></span> {tr("shippingaddresspanel.edit")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <blockquote>
                                    <address>
                                        {address.Name}<br />
                                        {address.Address1}<br />
                                        {address.Address2}<br />
                                        {address.City}<br />
                                        {address.Province + ", " + address.Country}<br />
                                        {address.PostalCode}<br />
                                    </address>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }.bind(this))

        var errorMessage = this.props.showRemoveShippingError
                         ? <modal.ConfirmOK showCloseButton={false} title={tr("shippingaddresspanel.failedremove")}
                                            messagehtml={tr("shippingaddresspanel.removeerror")}
                                            onOK={this.handleOnRemoveErrorShippingOK} />
                         : null

        //Si on est en mode edit
        var shippingPanel = this.state.showEditShippingAddressPanel
                          ? <EditShippingAddressPanel 
                                shippingAddress={this.state.shippingAddressToModify}
                                onModifyShippingAddress={(shippingAddressToModify) => this.handleOnModifyShippingAddress(shippingAddressToModify)}
                                onConfirmEditShippingAddress={(shippingAddressToModify) => this.handleOnConfirmEditShippingAddress(shippingAddressToModify)}
                                onCancelEditShippingAddress={() => this.handleOnCancelEditShippingAddress()}
                                onFailedEditShippingOK={this.handleOnFailedEditShippingOK}
                                shippingAddressErrorResult={this.state.shippingAddressErrorResult}
                                showEditShippingError={this.state.showEditShippingError} />
                          : <form>
                              <div ref={this.errorModalContainerRef} />
                              {errorMessage}
                              <h3 className="text-center">{tr("shippingaddresspanel.allshippingaddresses")}</h3>
                              {shippingAddressePanel}
                              <div className="row">
                                  <div className="col-xs-12">
                                      <div className="btn-toolbar pull-right">
                                          <button className="btn btn-default" type="button" onClick={() => this.handleOnClose()}>
                                              {tr("shippingaddresspanel.close")}
                                          </button>
                                          <button className="btn btn-primary" type="button" onClick={() => this.handleOnAddNewAddress()}>
                                              <span className="glyphicon glyphicon-plus"></span> {tr("shippingaddresspanel.addnew")}
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </form>
                          return (
                            <modal.EmptyBox showCloseButton={false} container={this.props.container}>
                                {shippingPanel}
                            </modal.EmptyBox>
                          )
    }
}

ShippingAddressPanel.propTypes = {
    onCloseShippingAddress: PropTypes.func,
    onRefreshData: PropTypes.func,
    container: PropTypes.object
}
